// removed by extract-text-webpack-plugin
module.exports = {"inputBox":"src-display-components-CommonInput-index__inputBox--y0loQ","message":"src-display-components-CommonInput-index__message--1SEwm"};


//////////////////
// WEBPACK FOOTER
// ./src/display/components/CommonInput/index.scss
// module id = 4146
// module chunks = 0